module.exports = __webpack_public_path__ + "img/dy.e3340919.png";